export const empidValidator = function(value, callback) {
  if (/^[a-zA-Z0-9]+$|^$/.test(value)) {
    callback(true);
  } else {
    callback(false);
  }
};

export const codeValidator = function(value, callback) {
    if (/^([a-zA-Z0-9_-]){1,10}$/.test(value)) {
        callback(true);
      } else {
        callback(false);
      }
}

export const nameValidator = function(value, callback) {
  if(value.length > 0 && value.length <= 100){
    if (/^([a-zA-Z0-9_/-]+( [a-zA-Z0-9_/-]+)*)$/.test(value)) {
      callback(true);
    } else {
      callback(false);
    }
  }else{
    callback(false)
  }
    // if (/^([a-zA-Z0-9_/\-]){1,100}$/.test(value)) {
    //     callback(true);
    //   } else {
    //     callback(false);
    //   }
}

export const typeValidator = function(value,callback) {
  if(value.length !== 0){
    callback(true)
  }else{
    callback(false)
  }
}
